import axios from 'axios';
import { deleteTokens } from '../auth';
import { toast } from 'react-toastify';
import { getCookie } from '../cookie';

const baseURL = process.env.REACT_APP_API_URL;

const http = axios.create({
    baseURL: baseURL,
});

http.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
};

const responseHandler = (response) => {
    // Handle responses
    return response;
};

const errorHandler = (error) => {
    switch (error.response.status) {
        case 401:
            deleteTokens();
            window.location.pathname = '/';
            break;
        case 404:
            toast.error(
                'The data you are trying to reach is temporary unavailable',
            );
            break;
        case 500:
            toast.error(error.response.data.message);
            break;
        default:
            toast.error(error?.response?.data?.message || error.message);
            break;
    }
    return Promise.reject(error);
};

http.interceptors.request.use((request) => {
    request.headers.Authorization = `Bearer ${getCookie('access_token')}`;
    return request;
});

http.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error),
);

export default http;
